import cn from 'classnames';
import { warehouseSamedayData } from '../cooperateData';

export default function WarehouseSameday() {
  return (
    <section className="desktop:pt-32 desktop:pb-16 desktop:bg-[url('/static/icons/service/SamedayBg.svg')] bg-primary-10 desktop:bg-white py-16">
      <div className="max-w-8xl desktop:px-8 mx-auto flex flex-col items-center justify-center px-4">
        <h2 className="text-title32 text-neutral-90 desktop:text-title42 mb-14 text-center font-bold">
          Quy trình giao hàng Sameday
        </h2>
        <nav aria-label="Progress" className="desktop:block hidden w-full">
          <ol className="flex w-full flex-row justify-center overflow-hidden">
            {warehouseSamedayData.map((item, idx) => (
              <li
                key={item.id}
                className={cn(
                  idx !== warehouseSamedayData.length - 1
                    ? 'desktop:w-[20%] desktop:pb-0 pb-10'
                    : '',
                  'group flex flex-col space-y-4'
                )}
              >
                <div className="relative flex w-full flex-row">
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div
                      className={cn(
                        'h-0 w-full border-t border-dashed border-neutral-50',
                        { hidden: idx === warehouseSamedayData.length - 1 }
                      )}
                    />
                  </div>
                  <div className=" bg-primary-50 group-hover:bg-primary-60 relative flex h-12 w-12 items-center justify-center rounded-full">
                    <p className="text-title24 font-bold text-white">
                      {item.id}
                    </p>
                  </div>
                </div>
                <p className="text-subtitle18 text-neutral-80 group-hover:text-primary-50 pr-6 font-semibold">
                  {item.title}
                </p>
              </li>
            ))}
          </ol>
        </nav>
        <nav aria-label="Progress" className="desktop:hidden w-full">
          <ol className="overflow-hidden">
            {warehouseSamedayData.map((item, idx) => (
              <li
                key={item.id}
                className={cn(
                  idx !== warehouseSamedayData.length - 1 ? 'pb-10' : '',
                  'relative'
                )}
              >
                {' '}
                {idx !== warehouseSamedayData.length - 1 ? (
                  <div
                    className="absolute top-6 left-6 -ml-px mt-0.5 h-full w-0 border-l border-dashed border-neutral-50"
                    aria-hidden="true"
                  />
                ) : null}
                <div className="group relative flex flex-row items-center space-x-4">
                  <div className="bg-primary-50 group-hover:bg-primary-60 relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
                    <p className="text-title24 font-bold text-white">
                      {item.id}
                    </p>
                  </div>
                  <p className="text-subtitle18 text-neutral-80 font-semibold">
                    {item.title}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </section>
  );
}
